import './growth.css';
import docs from '../../../data/docs';
import { useLang } from '../../../i18n/context';

export default function ArticleCards({ navigate }) {
  const { t } = useLang();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const articles = docs.filter(d => d.category === '财富认知');
  const displayArticles = isMobile ? articles.slice(0, 2) : articles;

  return (
    <section className="hp-section">
      <h2 className="hp-section-title">{t('home.growthArticlesTitle')}</h2>
      <p className="hp-section-desc">{t('home.growthArticlesDesc')}</p>
      <div className="hp-articles-grid">
        {displayArticles.map((article) => {
          const plainContent = article.content.replace(/[#*>\-|]/g, '').replace(/\n+/g, ' ').trim();
          const summary = plainContent.slice(0, 80) + '...';
          return (
            <div className="hp-article-card" key={article.id} onClick={() => navigate(`/docs/${article.id}`)}>
              <div className="hp-article-icon">
                <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                  <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 7h6M9 11h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
              <div className="hp-article-card-body">
                <div className="hp-article-card-title">{article.title}</div>
                <div className="hp-article-card-summary">{summary}</div>
              </div>
              <svg className="hp-tools-card-arrow" width="16" height="16" fill="none" viewBox="0 0 24 24">
                <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          );
        })}
      </div>
    </section>
  );
}
